// Where a code scanned in the app goes. Pure (scanTarget.test.js).
//
//   scan code    .../s/task-37114, /s/job-812, task-37114,  -> /s/<code> (ScanResolvePage
//                a beacon's /s/mtn-409 or /s/bcn-3            resolves it, as for a phone camera)
//   any JobQ link (consumable bin label /consumables?id=12, a job link, ...) -> that page,
//                 in THIS app (a prod label scanned in the dev app opens dev's page)
//   anything else -> a message; nothing is opened (a QR can hold any website).
import { parseScanCode, scanPath } from "../utils/scanCodes";

const JOBQ_HOSTS = new Set(["jobqworks.com", "www.jobqworks.com", "dev.jobqworks.com"]);

function isJobqUrl(u, origin) {
  if (u.origin === origin) return true;
  if (u.protocol !== "https:") return false;
  return JOBQ_HOSTS.has(u.hostname.toLowerCase());
}

export function scanTarget(text, { origin = window.location.origin } = {}) {
  const raw = text == null ? "" : String(text).trim();
  if (!raw) return { message: "Nothing was read." };

  const code = parseScanCode(raw);
  if (code) return { navigate: scanPath(code) };

  let u = null;
  try {
    u = /^[a-z][a-z0-9+.-]*:\/\//i.test(raw) ? new URL(raw) : null;
  } catch (e) {
    u = null;
  }
  if (u && isJobqUrl(u, origin)) {
    const path = `${u.pathname || "/"}${u.search}${u.hash}`;
    return { navigate: path };
  }

  const shown = raw.length > 80 ? `${raw.slice(0, 77)}…` : raw;
  return { message: `That isn't a JobQ code: "${shown}"` };
}
